import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
export const getNextDisabled = (allIds, id) => {
  if (localStorage.getItem(allIds) && id) {
    let currentItemIndex = JSON.parse(
      localStorage.getItem(allIds),
    ).indexOf(Number(id));
    if (
      currentItemIndex ==
      JSON.parse(localStorage.getItem(allIds)).length - 1
    ) {
      return true;
    } else {
      return false;
    }
  }
};
export const getPreviousDisabled = (allIds, id) => {
  if (localStorage.getItem(allIds) && id) {
    let currentItemIndex = JSON.parse(
      localStorage.getItem(allIds),
    ).indexOf(Number(id));
    if (currentItemIndex == 0) {
      return true;
    } else {
      return false;
    }
  }
};


export const previous = (allIds, id, page, pageSize, fsp, setFsp, entityLocalStorageKey, formPath, history) => {


  // JSON.parse
  if (setFsp && localStorage.getItem(allIds) && id) {
    let currentItemIndex = JSON.parse(
      localStorage.getItem(allIds),
    ).indexOf(Number(id));
    if (
      currentItemIndex != -1 &&
      JSON.parse(
        localStorage.getItem(allIds),
      )[currentItemIndex - 1]
    ) {
      // set current Page
      if (page && pageSize) {
        console.log(
          currentItemIndex - 1 + "/" + Number(pageSize),
        );
        let page = Math.floor(
          Number(currentItemIndex - 1) / Number(pageSize),
        );
        // pagination start from 1 not 0
        console.log("result page +1  is=>", page + 1);
        page = page + 1;
        setFsp({ ...fsp, page })
        localStorage.setItem(
          entityLocalStorageKey,
          JSON.stringify({
            ...JSON.parse(localStorage.getItem(entityLocalStorageKey)),
            page,
          }),
        );
      }

      history.push(formPath +
        JSON.parse(
          localStorage.getItem(allIds),
        )[currentItemIndex - 1],
      );
    }
  }
}

export const next = (allIds, id, page, pageSize, fsp, setFsp, entityLocalStorageKey, formPath, history) => {
  if (setFsp && localStorage.getItem(allIds) && id) {
    let currentItemIndex = JSON.parse(
      localStorage.getItem(allIds),
    ).indexOf(Number(id));
    if (
      currentItemIndex != -1 &&
      JSON.parse(
        localStorage.getItem(allIds),
      )[currentItemIndex + 1]
    ) {
      // set current Page
      if (page && pageSize) {
        console.log(
          currentItemIndex + 1 + "/" + Number(pageSize),
        );
        let page = Math.floor(
          Number(currentItemIndex + 1) / Number(pageSize),
        );
        // pagination start from 1 not 0
        console.log("result page +1  is=>", page + 1);
        page = page + 1;
        setFsp({ ...fsp, page })
        localStorage.setItem(
          entityLocalStorageKey,
          JSON.stringify({
            ...JSON.parse(localStorage.getItem(entityLocalStorageKey)),
            page,
          }),
        );
      }
      history.push(
        formPath +
        JSON.parse(
          localStorage.getItem(allIds),
        )[currentItemIndex + 1],
      );
    }
  }
}

export const goBack = (id, entityLocalStorageKey, listPath, currentPageIds, history) => {
  if (history) {
    history.push(listPath);
    // get table ref from local storage
    if (
      localStorage.getItem(currentPageIds) &&
      id &&
      JSON.parse(localStorage.getItem(entityLocalStorageKey))
    ) {
      let currentItemIndex = JSON.parse(
        localStorage.getItem(currentPageIds),
      ).indexOf(Number(id));

      setTimeout(() => {

        console.log(Number(localStorage.getItem("tablePosition")),  (currentItemIndex+2) * 35 );
        console.log((Number(localStorage.getItem("tablePosition")) +
        (currentItemIndex+2) * 35), window.innerHeight);
        // currentItemIndex+2 => +1 (because index start from 0)  +1  because of column name row
        //  scroll only if the item is not visible in the page (screen height < )
        if ((Number(localStorage.getItem("tablePosition")) +
          (currentItemIndex+2) * 35) > window.innerHeight) {
          scrollToPosition(
            Number(localStorage.getItem("tablePosition")) +
            (currentItemIndex+2) * 35,
          );
        }
      }, 1000);
    }
  }
}


export const validateAllFieldAndScrollToError = (validateForm, values, loadingContextAndErrorContext) => {

  if (validateForm) {
    validateForm(values).then((errors) => {
      if (Object.keys(errors).length != 0 && document.getElementsByName(Object.keys(errors)[0]) &&
        document.getElementsByName(Object.keys(errors)[0])[0]) {
        console.log("element offset is is ", document.getElementsByName(Object.keys(errors)[0])[0].offsetTop);
        scrollToPosition(document.getElementsByName(Object.keys(errors)[0])[0].offsetTop)
        // veuillez renseigner tous les champs obligatoires
        loadingContextAndErrorContext.snackbar.setOpen(true);
        loadingContextAndErrorContext.snackbar.setMsg(
          "Veuillez renseigner tous les champs obligatoires",
        );
        loadingContextAndErrorContext.snackbar.setSeverity("error");
      }
    })
  }

}

export const scrollToPosition = (position) => {
  document.getElementById('scroll-root').scrollTo(0, position)
}

export const dateFunctionFormat = dateformat => {
  // console.log("113" , dateformat)
  let date = new Date(dateformat);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let hours = date.getHours();
  let min = (date.getMinutes() < 10 ? "0" : "") + date.getMinutes();
  let dt = date.getDate();
  if (dt < 10) {
    dt = "0" + dt;
  }
  if (month < 10) {
    month = "0" + month;
  }
  // var resulta = dt + "-" + month + "-" + year + " " + hours + ":" + min;
  let dateFormat = dt + "-" + month + "-" + year;
  let hourFormat = hours + ":" + min;
  return { dateFormat, hourFormat };
};



export const dateFunctionMoment = (dateformat) => {
  if (!dateformat) {
    return dateformat
  }
  return moment(dateformat).format('YYYY-MM-DD')
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return;
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}


export const generateKey = () => uuidv4();

/**
 * converts an array to object with keys(keyField)
 * and value (if provided would be another key of item, if not the whole item)
 *
 * @param {*} array
 * @param {string} [keyField="id"]
 * @param {*} [value=null]
 * @returns {object}
 */
export const arrayToObject = (array, keyField = "id", value = null) =>
  array.reduce((obj, item) => ({ ...obj, [item[keyField]]: item[value] || item }), {});


export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export const getTraduction = (currentLanguage, key, FRENCH, ENGLISH) => {
  console.log(ENGLISH)
  switch (currentLanguage) {
    case "FRENCH":
      return FRENCH[key];
    case "ENGLISH":
      return ENGLISH[key];
    default:
      return key
  }
}

export const getTraductionFile = (currentLanguage, key, translation) => {

  if (translation[currentLanguage]) {
    return translation[currentLanguage][key] ? translation[currentLanguage][key] : key
  } else {
    return key
  }
}

export const MaskOnBlur = (elem = "", symbol = "", index = 2, empty) => {
  let repeatZero = "0".repeat(index)
  // in case of elem is null => prams initialization is not working
  if(elem === null){
    elem = ""
  }
  // first case the input is empty or 0 must add the symbol and initial it
  // must add all the zero after the ',' depends of index
  if ((elem === "" || elem == "0") && !empty) {
    return index === 0 ? `0 ${symbol}` : `0,${repeatZero} ${symbol}`
  } else if ((elem === "" || parseFloat(elem.toString().replace(",", ".")) == 0 ? true : false) && (empty === "empty")) {
    return ""
  }
  else {
    // The event of onBlur , the input must have spaces of each 3 numbers and add the symbol and use "," not "."
    let symb = symbol ? ` ${symbol}` : ""
    // will be match the two parts the first before the "," and the second part afte the "," 
    let splitted = elem.toString().replace(".", ",").split(",");
    let zeroN = splitted[1] ? (index - splitted[1].length) === 0 ? 0 : index - splitted[1].length : index
    let finalZero = "0".repeat(zeroN < 0 ? 0 : zeroN) // handle the case of the index of inputMask > of index Maskblur and value ll be negative
    // if the value after the comma not equal to the index , must add at the end N times 0 , to make all the numbers same level
    let value = splitted[1] ? "," + splitted[1] + finalZero : index === 0 ? "" : "," + repeatZero
    return splitted[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + value + symb

  }
}

export const MaskOnFocus = (elem = "", symbol) => {
  // The event of Focus , the input must have no spaces and delete the symbol
  if (elem) return elem.toString().replaceAll(symbol, "").replaceAll(" ", "")
  return ""
}

export const validateNumber = (elem, lastValid, index = 2) => {
 
  elem = elem.replace(".", ",")
  // input mask which allows only numbers , one comma and the numbers of decimal depends of index
  // if the value not valid will return the last valid value
  // new RegExp(/^\d*\.?\d{0,2}$/);
  let test = index ? index : 0;
  var pattern1 = '^\\d*';
  var pattern2 = `\\,?\\d{0,${index}}$`;
  // ^\d*\,?\d{0,2}$
  var pattern3 = '^\\d*$'
  let res = test == 0 ? pattern3 : pattern1 + pattern2

  var validNumber = new RegExp(res);
  if (validNumber.test(elem)) {
    return elem
  } else {
    return lastValid;
  }
};

export const TransformToNumber = (elem) => {
  // parse to float and delete the spaces and make off all the treatments of the masks
  elem = elem ? elem : 0
  return parseFloat(elem.toString().replaceAll(",", ".").replaceAll(" ", ""))
};

export const SortAlphabetically = (array, orderBy) => {
  return array.sort(function (a, b) {
    if (a[orderBy] === b[orderBy]) {
      return 0;
    }
    // nulls sort after anything else
    else if (a[orderBy] === null) {
      return 1;
    }
    else if (b[orderBy] === null) {
      return -1;
    }
    else {
      var textA = a[orderBy].toUpperCase()
      var textB = b[orderBy].toUpperCase()
      return textA < textB ? -1 : textA > textB ? 1 : 0;

    }
  });
}

export const sortArrayOfobjectByNumber = (array, numberKey) => {
  return array.sort((a, b) => a[numberKey] - b[numberKey]);
}


export const validateMultiNationalIban = (elem, lastValid) => {
  var multiIBanRegex = new RegExp(/[A-Z]{2}\d{2} ?\d{4} ?\d{4} ?\d{4} ?\d{4} ?[\d]{0,2}/)
  console.log("eee" , multiIBanRegex.test(elem))
  
  if (multiIBanRegex.test(elem)) {
    return elem
  } else {
    console.log(" */*/* NOT VALID ", elem)
    return lastValid;
  }
};


// generate an array of obje {months,year} from to given date 
// we can also generate an array of moonths days:
//  https://medium.com/better-programming/how-to-generate-an-array-of-months-years-or-days-in-javascript-add4b8419ff9
export const monthsYearsArray = (dateStart=moment(), dateEnd = moment().add(12, 'month')) => {
  const months = []
  while (dateEnd.diff(dateStart, 'months') >= 0) {
   months.push({"month":dateStart.format('MMMM'), "year": dateStart.format("YYYY") })
   dateStart.add(1, 'month')
  }
  return months
 }


 export const getSelectedShopLabel = (user) => {
  console.log("get labe", localStorage.getItem("selectedShopCode"));
  let index = user.licences.findIndex(
    item => item.licenceCode === localStorage.getItem("selectedShopCode"),
  );

  console.log("index", index);
  if (index != -1) {
    return user.licences[index].licenceName;
  }
};

export const isRelativeToTheCurrentMonth = (i) => {
  // beginDate < nextMonth first day
  if (moment(i.beginDate).minute(1).isBefore(moment().add(1, 'months').date(1).hour(0).minute(0).millisecond(0))) {
      if (i.endDate == null) {
          return true
      }
      else {
          //  endDate > current month first day
          return moment(i.endDate).minute(1).isSameOrAfter(moment().date(1).hour(0).minute(0).millisecond(0))
      }
  }
}

export const customDateFormatting = (dateformat) => {
  if (!dateformat) {
    return dateformat
  }
  // moment("accept specefic string format") moment( DD-MM-YYYY ) OK
  // in some case we have to parse moment(dateformat, "DD-MM-YYYY")
  // return moment(dateformat).format('DD-MM-YYYY') !="Invalid date"? moment(dateformat).format('DD-MM-YYYY') : moment(dateformat, "DD-MM-YYYY").format('DD-MM-YYYY')
  return moment(dateformat).format('DD-MM-YYYY')
};

// used to make diffirence Between preference && default_value_table
export const  diffirenceofArrays = (otherArray , firstKey , SecondKey) => {
  return function(current){
    return otherArray.filter(function(other){
      return other[firstKey] === current[SecondKey]
    }).length === 0;
  }
}
// used to remove tags html in case to display in table the data from the Editor
export const removeTagsHtml = (originalString)=>{
  return  originalString.replace(/<[^>]*>?/gm, '').replace(/\s\s+/g, ' ').trim()
  }

// use local storage for messaging. Set message in local storage and clear it right away
// This is a safe way how to communicate with other tabs while not leaving any traces
  export const  messageBroadcast=(message)=>{
    localStorage.setItem('message',JSON.stringify(message));
    localStorage.removeItem('message');
  }

export const messageReceive= (ev)=>{
  // console.log("ev issss =>", ev);
    if (ev.key!='message') return; // ignore other keys
    var message=JSON.parse(ev.newValue);
    if (!message) return; // ignore empty msg or msg reset
  alert(message.command)
    // here you act on messages.
    // you can send objects like { 'command': 'doit', 'data': 'abcd' }
    // if (message.command == 'doit') alert(message.data);

    // etc.
}
